(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omt-tea-quiz"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Questions and every UI label are rendered server-side (localized via the
    // omt.quiz.* locale keys) into the [data-omt-quiz-data] JSON block.
    var ICONS = {
      floral: 'M12 12m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0-5 0M12 9.5C10 6 10.5 3 12 2c1.5 1 2 4 0 7.5M14.4 11.2c2.2-3.3 5-4.2 6.5-3.4c.2 1.8-1.7 4-5.8 5.1M13.6 14.3c3.9.7 5.8 2.9 5.6 4.6c-1.6.9-4.5.2-6.6-3.3M10.4 14.3c-2.1 3.5-5 4.2-6.6 3.3c-.2-1.7 1.7-3.9 5.6-4.6M9.6 11.2C5.5 10.1 3.6 7.9 3.8 6.1c1.5-.8 4.3.1 6.5 3.4',
      creamy: 'M12 3c3 4 6 7.2 6 10.5a6 6 0 0 1-12 0C6 10.2 9 7 12 3zM9 14.5c1 1.5 3.5 1.8 5 .3',
      bold: 'M12 3c.5 3 4 5 4 9a4 4 0 0 1-8 0c0-1.8.8-3 2-4c0 1.5.6 2.5 1.5 3c.3-2.8-.3-5.5.5-8zM6 21h12',
      fruity: 'M12 7c-4.4 0-7 3.2-7 7s3 7 7 7s7-3.2 7-7s-2.6-7-7-7zM12 7c0 4-1 8-3 11M12 7c.5-2 2-3.5 4.5-4c-.3 2.3-2 3.6-4.5 4',
      notsure: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0-18 0M15.5 8.5l-2 5-5 2 2-5z',
      calm: 'M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z',
      focus: 'M12 12m-8 0a8 8 0 1 0 16 0a8 8 0 1 0-16 0M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0-8 0M12 12m-.8 0a.8.8 0 1 0 1.6 0a.8.8 0 1 0-1.6 0',
      energy: 'M12 4v2M5.6 6.6l1.4 1.4M18.4 6.6L17 8M3 13h2M19 13h2M8 13a4 4 0 0 1 8 0M3 19l5-5 3 3 3-2 7 4',
      beginner: 'M12 21v-9M12 12c0-3.5-2.5-6-7-6c0 3.5 2.5 6 7 6zM12 14c0-3 2-5.5 6-5.5c0 3-2 5.5-6 5.5z',
      explorer: 'M3 20l6.5-10 3.5 5 2-3 6 8zM9.5 10V4l4 1.5-4 1.5',
      milk: 'M6.5 8h11l-1.3 12a1.6 1.6 0 0 1-1.6 1.4H9.4a1.6 1.6 0 0 1-1.6-1.4zM5.5 8h13M13.5 8l1.8-6M7.2 12.5h9.6M9.3 17.2a.8.8 0 1 0 1.6 0a.8.8 0 1 0-1.6 0M12.6 18.4a.8.8 0 1 0 1.6 0a.8.8 0 1 0-1.6 0M11.4 15.4a.8.8 0 1 0 1.6 0a.8.8 0 1 0-1.6 0'
    };
    // Waypoints on the trail (SVG user units, viewBox 1440x640): Trailhead, Q1, Q2, Q3, Summit.
    var WAY = [[110, 606], [400, 592], [700, 570], [1060, 537], [1390, 481]];
    var OPT_ROT = [-1.2, 0.9, 0.7, -0.8, 0.3];

    function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function svgPath(d, size, sw) {
      return '<svg aria-hidden="true" focusable="false" width="' + size + '" height="' + size + '" viewBox="0 0 24 24"><path d="' + d + '" fill="none" stroke="#2F5569" stroke-width="' + sw + '" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
    }

    function scoreAndPick(a, teas, surprise) {
      var keys = ['flavor', 'effect', 'level'];
      var none = keys.every(function (k) { return !a[k] || a[k] === 'notsure'; });
      if (none) {
        var s = (surprise || []).map(function (h) { return teas.filter(function (t) { return t.handle === h; })[0]; }).filter(Boolean);
        // Top up from the list if a surprise tea is sold out.
        teas.forEach(function (t) { if (s.length < 3 && s.indexOf(t) < 0) s.push(t); });
        return s;
      }
      return teas.map(function (t, i) {
        var s = 0;
        if (a.flavor && a.flavor !== 'notsure' && t.flavor === a.flavor) s += 4;
        if (a.effect === 'milk') {
          if (t.effects.indexOf('milk') > -1) s += 6;
        } else if (a.effect && a.effect !== 'notsure' && t.effects.indexOf(a.effect) > -1) {
          s += t.effects[0] === a.effect ? 2.5 : 2;
        }
        if (a.level && a.level !== 'notsure' && t.level === a.level) s += 1;
        return { t: t, s: s, i: i };
      }).sort(function (x, y) { return (y.s - x.s) || (x.i - y.i); }).slice(0, 3).map(function (x) { return x.t; });
    }

    function initQuiz(root) {
      if (root.__omtQuiz) return;
      var data;
      try { data = JSON.parse(root.querySelector('[data-omt-quiz-data]').textContent); }
      catch (e) { return; }
      var teas = data.teas || [], disc = data.discovery || {};
      var U = data.ui || {}, TAGS = U.tags || {}, QUESTIONS = data.questions || [];
      if (!QUESTIONS.length || !teas.length) return;
      root.__omtQuiz = true;

      var intro = root.querySelector('[data-omt-quiz-start]');
      var introH = intro.querySelector('h2');
      var stage = root.querySelector('[data-omt-quiz-panel]');
      var live = root.querySelector('[data-fq-live]');
      var beginBtn = root.querySelector('[data-omt-quiz-begin]');
      var here = root.querySelector('[data-fq-here]');
      var flag = root.querySelector('[data-fq-flag]');
      var answers = {}, step = 0;

      function announce(msg) {
        if (!live) return;
        live.textContent = '';
        window.setTimeout(function () { live.textContent = msg; }, 60);
      }
      function focusEl(el) { if (el) { el.setAttribute('tabindex', '-1'); el.focus({ preventScroll: true }); } }

      // cur: 0 = trailhead (intro), 1..3 = questions, 4 = summit (results)
      function setTrail(cur) {
        for (var i = 0; i < 4; i++) {
          var c = root.querySelector('[data-fq-way="' + i + '"]');
          if (!c) continue;
          if (i < cur) { c.setAttribute('r', 9); c.setAttribute('fill', '#D9A441'); c.setAttribute('stroke', '#D9A441'); }
          else if (i === cur) { c.setAttribute('r', 13); c.setAttribute('fill', '#F4ECDA'); c.setAttribute('stroke', '#D9A441'); }
          else { c.setAttribute('r', 9); c.setAttribute('fill', '#3A6076'); c.setAttribute('stroke', '#D9C9A3'); }
        }
        if (flag) flag.setAttribute('fill', cur === 4 ? '#D9A441' : 'transparent');
        if (here) {
          if (cur === 4) { here.setAttribute('visibility', 'hidden'); }
          else {
            here.setAttribute('visibility', 'visible');
            here.setAttribute('x', WAY[cur][0] - 58);
            here.setAttribute('y', WAY[cur][1] - 26);
          }
        }
      }

      function showIntro(focus) {
        stage.hidden = true;
        stage.innerHTML = '';
        intro.hidden = false;
        setTrail(0);
        if (focus) focusEl(introH);
      }

      function renderQuestion() {
        var q = QUESTIONS[step];
        var qLabel = U.question + ' ' + (step + 1) + ' ' + U.of + ' ' + QUESTIONS.length;
        var opts = q.options.map(function (o, i) {
          var on = answers[q.key] === o.value;
          return '<button type="button" class="fq-opt fj-rot' + (o.wide ? ' fq-opt--wide' : '') + '" style="--r:' + (OPT_ROT[i] || 0) + 'deg" aria-pressed="' + (on ? 'true' : 'false') + '" data-val="' + esc(o.value) + '">' +
            '<span class="fq-opt__icon" aria-hidden="true">' + svgPath(ICONS[o.value] || ICONS.notsure, 24, 1.5) + '</span>' +
            '<span class="fq-opt__txt"><span class="fq-opt__label">' + esc(o.label) + '</span>' +
            (o.hint ? '<span class="fq-opt__hint">' + esc(o.hint) + '</span>' : '') + '</span>' +
            (on ? '<span class="fq-opt__pick fj-type" aria-hidden="true">' + esc(U.your_pick) + '</span>' : '') +
          '</button>';
        }).join('');
        intro.hidden = true;
        stage.hidden = false;
        stage.innerHTML =
          '<div class="fq-q fq-step">' +
            '<div class="fq-q__head">' +
              '<p class="fq-eyebrow fj-type">' + esc(qLabel) + '</p>' +
              '<h2 class="fq-h fq-h--q" tabindex="-1">' + esc(q.title) + '</h2>' +
              '<button type="button" class="fq-ghost fj-type" data-fq-back>' +
                '<svg aria-hidden="true" focusable="false" width="20" height="12" viewBox="0 0 20 12"><path d="M19 6H2M7 1L2 6l5 5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path></svg>' +
                esc(U.back) + '</button>' +
            '</div>' +
            '<div class="fq-opts" role="group" aria-label="' + esc(q.title) + '">' + opts + '</div>' +
          '</div>';
        setTrail(step + 1);
        announce(qLabel);
        focusEl(stage.querySelector('h2'));

        // One pick per question: a second click during the short advance delay
        // (e.g. a double-click) must not advance twice and skip a question.
        var picked = false;
        stage.querySelectorAll('.fq-opt').forEach(function (btn) {
          btn.addEventListener('click', function () {
            if (picked) return;
            picked = true;
            answers[q.key] = btn.getAttribute('data-val');
            stage.querySelectorAll('.fq-opt').forEach(function (b) {
              var on = b === btn;
              b.setAttribute('aria-pressed', on ? 'true' : 'false');
              var pick = b.querySelector('.fq-opt__pick');
              if (on && !pick) b.insertAdjacentHTML('beforeend', '<span class="fq-opt__pick fj-type" aria-hidden="true">' + esc(U.your_pick) + '</span>');
              if (!on && pick) pick.remove();
            });
            window.setTimeout(function () {
              if (step < QUESTIONS.length - 1) { step++; renderQuestion(); }
              else { renderResults(); }
            }, reduced() ? 0 : 220);
          });
        });
        stage.querySelector('[data-fq-back]').addEventListener('click', function () {
          if (step > 0) { step--; renderQuestion(); }
          else { showIntro(true); }
        });
      }

      function tagLine(t) {
        return [TAGS[t.flavor]].concat(t.effects.map(function (e) { return TAGS[e]; })).concat([TAGS[t.level]])
          .filter(Boolean).join('  ·  ');
      }

      function renderResults() {
        var picks = scoreAndPick(answers, teas, data.surprise);
        var best = picks[0];
        var trail = QUESTIONS.map(function (q) {
          var o = q.options.filter(function (x) { return x.value === answers[q.key]; })[0];
          if (!o) return '?';
          return o.value === 'notsure' ? U.not_sure_short : o.label;
        }).join('  →  ');

        var photo = best.img
          ? '<img src="' + esc(best.img) + '" alt="" width="112" height="112" loading="lazy">'
          : svgPath(ICONS[best.flavor] || ICONS.notsure, 56, 1.2);

        var more = picks.slice(1).map(function (t, i) {
          return '<article class="fq-also__card fj-paper fj-rot" style="--r:' + (i ? 1.2 : -1) + 'deg">' +
            '<h4>' + esc(t.title) + '</h4>' +
            (t.note ? '<p class="fq-also__note">' + esc(t.note) + '</p>' : '') +
            '<div class="fq-also__foot"><span class="fj-type">' + esc(t.price) + '</span>' +
            '<a href="' + esc(t.url) + '" class="fj-type fj-tap">' + esc(U.view_tea) + ' <span aria-hidden="true">&rarr;</span><span class="fj-vh">: ' + esc(t.title) + '</span></a></div>' +
          '</article>';
        }).join('');

        var slip = disc.url
          ? '<div class="fq-slip fj-lift fj-rot"><p class="fj-paper">' + esc(U.torn_pre) + '<a href="' + esc(disc.url) + '">' + esc(U.torn_link) + '</a>' + esc(U.torn_post) +
            (disc.price ? ' <span class="fj-type">· ' + esc(disc.price) + '</span>' : '') + '</p></div>'
          : '';

        intro.hidden = true;
        stage.hidden = false;
        stage.innerHTML =
          '<div class="fq-res fq-step">' +
            '<div class="fq-res__head">' +
              '<p class="fq-eyebrow fj-type">' + esc(U.summit) + '</p>' +
              '<h2 class="fq-h fq-h--res" tabindex="-1">' + esc(U.result_one) + '</h2>' +
              '<p class="fq-res__label fj-type">' + esc(U.trail_label) + '</p>' +
              '<p class="fq-res__trail fj-hand">' + esc(trail) + '</p>' +
              '<div class="fq-res__actions">' +
                '<button type="button" class="fq-ticket fq-ticket--sm fj-type" data-fq-restart>' + esc(U.start_over) + '</button>' +
                '<button type="button" class="fq-ghost fj-type" data-fq-back><span aria-hidden="true">&larr;</span> ' + esc(U.back) + '</button>' +
              '</div>' +
            '</div>' +
            '<div class="fq-res__picks">' +
              '<div class="fq-best fj-lift fj-rot">' +
                '<article class="fq-best__tag fj-kraft">' +
                  '<span class="fj-tag__hole" aria-hidden="true"></span>' +
                  '<div class="fq-best__photo fj-polaroid fj-rot"><div class="fj-polaroid__img">' + photo + '</div><span class="fj-tape fj-hide-sm" aria-hidden="true"></span></div>' +
                  '<div class="fq-best__body">' +
                    '<span class="fq-best__eyebrow fj-type">' + esc(U.best_match) + '</span>' +
                    '<h3 class="fq-best__title">' + esc(best.title) + '</h3>' +
                    '<p class="fq-best__note">' + esc(best.note) + '</p>' +
                    '<p class="fq-best__tags fj-type">' + esc(tagLine(best)) + '</p>' +
                    '<div class="fq-best__foot"><span class="fj-type">' + esc(best.price) + '</span>' +
                      '<a href="' + esc(best.url) + '" class="fj-type fj-dark-link fj-tap">' + esc(U.view_tea) + ' <span aria-hidden="true">&rarr;</span><span class="fj-vh">: ' + esc(best.title) + '</span></a></div>' +
                  '</div>' +
                '</article>' +
                '<svg class="fq-best__stamp" aria-hidden="true" focusable="false" width="96" height="96" viewBox="0 0 96 96"><circle cx="48" cy="48" r="42" fill="none" stroke="#9C3B2A" stroke-width="2.5"></circle><circle cx="48" cy="48" r="34" fill="none" stroke="#9C3B2A" stroke-width="1"></circle>' +
                  '<text x="48" y="45" text-anchor="middle" font-family="Special Elite, monospace" font-size="11" fill="#9C3B2A">' + esc(U.summit_pick_1) + '</text>' +
                  '<text x="48" y="61" text-anchor="middle" font-family="Special Elite, monospace" font-size="11" fill="#9C3B2A">' + esc(U.summit_pick_2) + '</text></svg>' +
              '</div>' +
              (more ? '<p class="fq-also-label fj-type">' + esc(U.also) + '</p><div class="fq-also">' + more + '</div>' : '') +
            '</div>' +
            slip +
          '</div>';
        setTrail(4);
        announce(U.summit + '. ' + U.result_one);
        focusEl(stage.querySelector('h2'));

        stage.querySelector('[data-fq-restart]').addEventListener('click', function () {
          answers = {}; step = 0; showIntro(true);
        });
        stage.querySelector('[data-fq-back]').addEventListener('click', function () {
          step = QUESTIONS.length - 1; renderQuestion();
        });
      }

      if (beginBtn) beginBtn.addEventListener('click', function () { step = 0; answers = {}; renderQuestion(); });
    }

    function initAll(scope) { (scope || document).querySelectorAll('[data-omt-quiz]').forEach(initQuiz); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
